import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="bg-slate-950 text-slate-400 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5 mb-4">
            <span className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-black overflow-hidden">
              <img src="/brand/dh-logo.png" alt="DH Web Services" className="w-10 h-10 object-contain" />
            </span>
            <div className="leading-tight">
              <p className="font-display font-bold text-white text-[15px]">DH Web Services</p>
              <p className="text-[12px] text-slate-400">Free Website Initiative</p>
            </div>
          </div>
          <p className="text-slate-400 max-w-md leading-relaxed text-[15px]">
            We build professional websites for small businesses that can&apos;t afford one. Funded by sponsors, transparent by default.
          </p>
          <p className="mt-6 text-[13px] text-slate-500 max-w-md leading-relaxed">
            This initiative is run by DH Website Services. <span className="text-slate-300 font-medium">100% of funds raised go directly into builds.</span>
          </p>
        </div>

        <div>
          <p className="eyebrow text-blue-400 mb-4">Initiative</p>
          <ul className="space-y-3 text-[14px]">
            <li><Link to="/apply" data-testid="footer-link-apply" className="hover:text-white transition-colors">Apply</Link></li>
            <li><Link to="/donate" data-testid="footer-link-donate" className="hover:text-white transition-colors">Donate</Link></li>
            <li><a href="#how-it-works" className="hover:text-white transition-colors">How it works</a></li>
            <li><a href="#impact" className="hover:text-white transition-colors">Impact</a></li>
          </ul>
        </div>

        <div>
          <p className="eyebrow text-blue-400 mb-4">Contact</p>
          <ul className="space-y-3 text-[14px]">
            <li>
              <a
                href="mailto:foundation@dhwebsiteservices.co.uk"
                data-testid="footer-contact-email"
                className="hover:text-white transition-colors"
              >
                foundation@dhwebsiteservices.co.uk
              </a>
            </li>
            <li>
              <a href="https://dhwebsiteservices.co.uk" target="_blank" rel="noreferrer" className="hover:text-white transition-colors">
                dhwebsiteservices.co.uk
              </a>
            </li>
            <li>
              <Link to="/admin/login" data-testid="footer-link-admin" className="hover:text-white transition-colors">
                Admin
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between gap-3 text-[13px] text-slate-500">
          <p>© {new Date().getFullYear()} DH Website Services. All rights reserved.</p>
          <p>Built by professionals. Funded by sponsors. Owned by you.</p>
        </div>
      </div>
    </footer>
  );
}
